var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var SHOP_ROOT = '/shop';
function parseQueryString(queryString) {
    if (queryString === void 0) { queryString = ''; }
    return queryString
        .split('&')
        .filter(Boolean)
        .map(function (pair) { return pair.split('='); })
        .reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
    }, {});
}
export var deriveTopicNavState = function (path, config) {
    /*
    The locations take the following forms:
  
    /shop/<topic>
    /shop/<product>
    /shop/<topic>+<product>
    /shop?query=<search_term>   (from the search bar; not generated by us)
  
  A ?query= term drives an active topic or product when it matches a
  configured topic/product slug; otherwise no topic/product is considered active.
    */
    var _a, _b, _c, _d;
    var _e = path.split('?').filter(Boolean), pathname = _e[0], _f = _e[1], queryString = _f === void 0 ? '' : _f;
    var rawSearchQuery = parseQueryString(queryString).query;
    var _g = ((_a = pathname === null || pathname === void 0 ? void 0 : pathname.split('/')) !== null && _a !== void 0 ? _a : []).filter(Boolean), root = _g[0], item = _g[1];
    var _h = (_b = item === null || item === void 0 ? void 0 : item.split('+')) !== null && _b !== void 0 ? _b : [], rawTopic = _h[0], rawConjunctProduct = _h[1];
    if (root !== 'shop')
        return {};
    if (rawConjunctProduct) {
        var isTopic = config.topics.some(function (_a) {
            var topic = _a.category.topic;
            return topic === rawTopic;
        });
        var isProduct = config.products.some(function (_a) {
            var product = _a.category.product;
            return product === rawConjunctProduct;
        });
        if (isTopic && isProduct) {
            return { topic: rawTopic, product: rawConjunctProduct };
        }
        return {};
    }
    var topic = (_c = config.topics.find(function (_a) {
        var topic = _a.category.topic;
        return topic === rawTopic || topic === rawSearchQuery;
    })) === null || _c === void 0 ? void 0 : _c.category.topic;
    var product = (_d = config.products.find(function (_a) {
        var product = _a.category.product;
        return product === item || product === rawSearchQuery;
    })) === null || _d === void 0 ? void 0 : _d.category.product;
    return { topic: topic, product: product };
};
var setOrRemove = function (target, current) {
    if (target === current)
        return undefined;
    if (target) {
        return target;
    }
    return current;
};
export function buildTopicNavHref(_a, _b) {
    var targetTopic = _a.topic, targetProduct = _a.product;
    var currentTopic = _b.topic, currentProduct = _b.product;
    var unEscapedTopic = setOrRemove(targetTopic, currentTopic);
    var unEscapedProduct = setOrRemove(targetProduct, currentProduct);
    var topic = unEscapedTopic && encodeURIComponent(unEscapedTopic);
    var product = unEscapedProduct && encodeURIComponent(unEscapedProduct);
    if (topic) {
        var topicHref = [SHOP_ROOT, topic].join('/');
        if (product) {
            return [topicHref, product].join('+');
        }
        return topicHref;
    }
    if (product) {
        return [SHOP_ROOT, product].join('/');
    }
    if (!targetTopic && !targetProduct && !currentTopic && !currentProduct) {
        return undefined;
    }
    return SHOP_ROOT;
}
export var isActiveSelection = function (itemCategory, _a) {
    var currentNavTopic = _a.topic, currentNavProduct = _a.product;
    return ((itemCategory.topic === currentNavTopic && !!currentNavTopic) ||
        (itemCategory.product === currentNavProduct && !!currentNavProduct));
};
